import { FC } from 'react';
import { CheckCircle2, Clock, XCircle } from 'lucide-react';
import { TransactionStatus } from '../types/ApiTransaction';
import { useTranslation } from 'react-i18next';

interface TransactionStatusIconProps {
  status: TransactionStatus;
}

export const TransactionStatusIcon: FC<TransactionStatusIconProps> = ({ status }) => {
  const { t } = useTranslation();

  switch (status) {
    case 'pending_checkout':
    case 'pending_return':
      return (
        <span title={t('Pending approval').toString()}>
          <Clock size={18} color="#f0ad4e" />
        </span>
      );
    case 'active':
    case 'completed':
      return (
        <span title={t('Confirmed').toString()}>
          <CheckCircle2 size={18} color="#5cb85c" />
        </span>
      );
    case 'cancelled':
      return (
        <span title={t('Cancelled').toString()}>
          <XCircle size={18} color="#d9534f" />
        </span>
      );
    default:
      return null;
  }
};
